<script setup>

</script>

<template>
  <div class="container">
    <div class="header"><span class="login"><a
        href="/login">已有账号请点击登录~</a></span></div><!-- end header -->
    <hr>
    <form>
      <input type="text" name="username" id="username" placeholder="用户名">
      <input type="email" name="email" id="email" placeholder="Email">
      <input type="password" name="password" id="password" placeholder="密码">
      <input type="password" name="password" id="password" placeholder="确认密码">
      <div class="help-block">创建账号需要遵守<a>用户协议</a></div>
      <input type="submit" value="创建账号"></form>
  </div>
</template>

<style scoped>

</style>